if (!customElements.get('frequently-bought-products')) {
    class FrequentlyBoughtProducts extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.submitButton = this.querySelector('[type="submit"]');
            this.submitButtonText = this.submitButton.querySelector('span');
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.fbtProducts = this.querySelectorAll('.fbt-checkbox');
            this.fbtTotalSelector = this.querySelector('.fbt-total-value');
            this.fbtTotalAmount = this.fbtTotalSelector.querySelector('#fbt-total');

            this.setupEventListeners();
            this.updateTotal();
            this.toggleSubmitButton();
        }

        setupEventListeners() {
            this.fbtProducts.forEach((item) => item.addEventListener('change', this.onChange.bind(this)));
        }

        onChange() {
            this.updateTotal();
            this.toggleSubmitButton();
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            const items = this.selectedProducts;
            if (items.length <= 0) return;

            let formData = {
                items: items.map(item => ({ id: parseInt(item.value), quantity: 1 }))
            };
            const config = fetchConfig();
            if (this.cart) {
                formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
                formData['sections_url'] = window.location.pathname;
                this.cart.setActiveElement(document.activeElement);
            }
            config.body = JSON.stringify(formData);

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    this.error = false;
                    this.cart.renderContents(response);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    this.querySelector('.loading__spinner').classList.add('hidden');
                });
        }

        toggleSubmitButton() {
            if (this.selectedProducts.length <= 0) {
                this.submitButton.setAttribute('disabled', 'disabled');
                const hasDisable = Array.from(this.fbtProducts).filter(item => item.checked && item.disabled).length;
                if (hasDisable > 0) this.submitButtonText.textContent = window.variantStrings.soldOut;
                this.fbtTotalSelector.classList.add('hidden');
            } else {
                this.submitButton.removeAttribute('disabled');
                this.submitButtonText.textContent = window.variantStrings.addToCart;
                this.fbtTotalSelector.classList.remove('hidden');
            }
        }

        updateTotal() {
            const total = this.selectedProducts.reduce((sum, item) => {
                return sum + Number(item.dataset.price);
            }, 0);

            const currentCurrency = window.Shopify?.currency?.active || 'INR';

            let formattedPrice = (total / 100).toLocaleString('en-IN', {
                style: 'currency',
                currency: currentCurrency
            });
            if (currentCurrency === 'INR') {
                formattedPrice = formattedPrice.replace('₹', 'Rs. ');
            }
            this.fbtTotalAmount.innerHTML = formattedPrice;
        }

        get selectedProducts() {
            return Array.from(this.fbtProducts).filter(item => item.checked && !item.disabled);
        }
    }
    customElements.define('frequently-bought-products', FrequentlyBoughtProducts);
}